import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { TICKET_PRIORITY } from "@/constants/tickets";

const BLANK = { subject: "", description: "", group_id: "", priority: "medium", due_date: "" };

export function CreateTicketDialog({ groups, open, setOpen, onCreated, trigger }) {
  const [form, setForm] = useState(BLANK);
  const submit = async () => {
    if (!form.subject.trim()) return toast.error("Subject required");
    if (!form.group_id) return toast.error("Choose a team");
    try { const { data } = await api.post("/tickets", form); toast.success("Ticket created"); setOpen(false); setForm(BLANK); onCreated?.(data); }
    catch (e) { console.error("create ticket", e); toast.error(e?.response?.data?.detail || "Could not create ticket"); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger || <Button data-testid="new-ticket-btn"><Plus className="h-4 w-4 mr-1.5" />New Ticket</Button>}</DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Submit a ticket</DialogTitle><DialogDescription>Route your request to the right team.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Subject *</Label><Input data-testid="ticket-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs">Team / Group *</Label>
              <Select value={form.group_id} onValueChange={(v) => setForm({ ...form, group_id: v })}>
                <SelectTrigger data-testid="ticket-group"><SelectValue placeholder="Choose…" /></SelectTrigger>
                <SelectContent>{groups.map((g) => <SelectItem key={g.id} value={g.id}>{g.name}</SelectItem>)}</SelectContent>
              </Select></div>
            <div><Label className="text-xs">Priority</Label>
              <Select value={form.priority} onValueChange={(v) => setForm({ ...form, priority: v })}>
                <SelectTrigger data-testid="ticket-priority"><SelectValue /></SelectTrigger>
                <SelectContent>{Object.keys(TICKET_PRIORITY).map((p) => <SelectItem key={p} value={p}>{TICKET_PRIORITY[p].label}</SelectItem>)}</SelectContent>
              </Select></div>
          </div>
          <div><Label className="text-xs">Description</Label><Textarea rows={5} data-testid="ticket-description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          <div><Label className="text-xs">Needed by (optional)</Label><Input type="date" data-testid="ticket-due" value={form.due_date} onChange={(e) => setForm({ ...form, due_date: e.target.value })} /></div>
        </div>
        <DialogFooter><Button data-testid="ticket-submit" onClick={submit}>Submit ticket</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
